import { TableCell } from 'types/common/table';
import { BackOrderComment } from 'types/api/backorder';
import { getUtcUSFormatDateWithTime } from 'modules/utils/time';

export const commentHistoryTableColumns: TableCell<BackOrderComment>[] = [
  {
    name: 'No.',
    key: 'no',
    align: 'center',
    width: '5%',
  },
  {
    name: 'Back Order',
    key: 'backOrder',
    align: 'left',
    width: '20%',
  },
  {
    name: 'Description',
    key: 'description',
    align: 'left',
    width: '43%',
  },
  {
    name: 'Posted Date',
    key: 'postedDate',
    align: 'center',
    width: '17%',
    render: ({ postedDate }) => `UTC: ${getUtcUSFormatDateWithTime(postedDate, true)}`,
  },
  {
    name: 'CLO-SET Manager',
    key: 'operator',
    align: 'left',
    width: '15%',
  },
];

export const commentHistoryTableHeader = commentHistoryTableColumns.map(({ name, key }) => {
  return {
    name,
    key,
  };
});
